export async function requestSendDanmaku(danmu: newDan) {
  return http.post<void>('/v1/danmaku/send_normal', danmu)
}
